//DIFFERENTES FONCTIONNALITÉS DISPONIBLES

export const FUNCTIONNALITY_CREATE_REFERENCE = "FunctionnalityCreateReference";
export const FUNCTIONNALITY_LISTING_REFERENCE =
  "FunctionnalityListingReference";
export const FUNCTIONNALITY_UPDATE_REFERENCE = "FunctionnalityUpdateReference";
export const FUNCTIONNALITY_DELETE_REFERENCE = "FunctionnalityDeleteReference";

export const FUNCTIONNALITY_CREATE_PAYS = "FunctionnalityCreatePays";
export const FUNCTIONNALITY_LISTING_PAYS = "FunctionnalityListingPays";
export const FUNCTIONNALITY_UPDATE_PAYS = "FunctionnalityUpdatePays";
export const FUNCTIONNALITY_DELETE_PAYS = "FunctionnalityDeletePays";

export const FUNCTIONNALITY_CREATE_VILLE = "FunctionnalityCreateVille";
export const FUNCTIONNALITY_LISTING_VILLE = "FunctionnalityListingVille";
export const FUNCTIONNALITY_UPDATE_VILLE = "FunctionnalityUpdateVille";
export const FUNCTIONNALITY_DELETE_VILLE = "FunctionnalityDeleteVille";

export const FUNCTIONNALITY_DEMANDE_ADHESION = "FunctionnalityDemandeAdhesion";
export const FUNCTIONNALITY_LIST_ADHESION = "FunctionnalitySelectAdhesion";
export const FUNCTIONNALITY_CREATE_COMPAGNIE_TRANSPORT =
  "FunctionnalityCreateCompagnieTransport";
export const FUNCTIONNALITY_UPDATE_COMPAGNIE_TRANSPORT =
  "FunctionnalityUpdateCompagnieTransport";
export const FUNCTIONNALITY_DELETE_COMPAGNIE_TRANSPORT =
  "FunctionnalityDeleteCompagnieTransport";
export const FUNCTIONNALITY_LISTING_COMPAGNIE_TRANSPORT =
  "FunctionnalityListingCompagnieTransport";
export const FUNCTIONNALITY_LISTING_COMPAGNIE_TRANSPORT_VALIDE =
  "FunctionnalityListingCompagnieTransportValide";
export const FUNCTIONNALITY_VALIDATE_COMPAGNIE_TRANSPORT =
  "FunctionnalityValidateCompagnieTransport";
export const FUNCTIONNALITY_RATTACHE_ATTESTION_TRANSPORT =
  "FunctionnalityRattacheAttestionTransport";
export const FUNCTIONNALITY_READ_RATTACHE_ATTESTION_TRANSPORT =
  "FunctionnalityReadRattacheAttestionTransport";

export const FUNCTIONNALITY_CREATE_OFFRE_VOYAGE =
  "FunctionnalityCreateOffreVoyage";
export const FUNCTIONNALITY_UPDATE_OFFRE_VOYAGE =
  "FunctionnalityUpdateOffreVoyage";
export const FUNCTIONNALITY_DELETE_OFFRE_VOYAGE =
  "FunctionnalityDeleteOffreVoyage";
export const FUNCTIONNALITY_LISTING_OFFRE_VOYAGE =
  "FunctionnalityListingOffreVoyage";
export const FUNCTIONNALITY_ENABLE_OFFRE_VOYAGE =
  "FunctionnalityEnableOffreVoyage";
export const FUNCTIONNALITY_DISABLE_OFFRE_VOYAGE =
  "FunctionnalityDisableOffreVoyage";

export const FUNCTIONNALITY_CREATE_PRIX_OFFRE_VOYAGE =
  "FunctionnalityCreatePrixOffreVoyage";
export const FUNCTIONNALITY_UPDATE_PRIX_OFFRE_VOYAGE =
  "FunctionnalityUpdatePrixOffreVoyage";
export const FUNCTIONNALITY_DELETE_PRIX_OFFRE_VOYAGE =
  "FunctionnalityDeletePrixOffreVoyage";
export const FUNCTIONNALITY_LISTING_PRIX_OFFRE_VOYAGE =
  "FunctionnalityListingPrixOffreVoyage";

export const FUNCTIONNALITY_CREATE_BUS_OFFRE_VOYAGE =
  "FunctionnalityCreateBusOffreVoyage";
export const FUNCTIONNALITY_UPDATE_BUS_OFFRE_VOYAGE =
  "FunctionnalityUpdateBusOffreVoyage";
export const FUNCTIONNALITY_DELETE_BUS_OFFRE_VOYAGE =
  "FunctionnalityDeleteBusOffreVoyage";
export const FUNCTIONNALITY_LISTING_BUS_OFFRE_VOYAGE =
  "FunctionnalityListingBusOffreVoyage";

export const FUNCTIONNALITY_CREATE_JOUR_OFFRE_VOYAGE =
  "FunctionnalityCreateJourOffreVoyage";
export const FUNCTIONNALITY_UPDATE_JOUR_OFFRE_VOYAGE =
  "FunctionnalityUpdateJourOffreVoyage";
export const FUNCTIONNALITY_DELETE_JOUR_OFFRE_VOYAGE =
  "FunctionnalityDeleteJourOffreVoyage";
export const FUNCTIONNALITY_LISTING_JOUR_OFFRE_VOYAGE =
  "FunctionnalityListingJourOffreVoyage";

export const FUNCTIONNALITY_CREATE_PROGRAMME_OFFRE_VOYAGE =
  "FunctionnalityCreateProgrammeOffreVoyage";
export const FUNCTIONNALITY_UPDATE_PROGRAMME_OFFRE_VOYAGE =
  "FunctionnalityUpdateProgrammeOffreVoyage";
export const FUNCTIONNALITY_DELETE_PROGRAMME_OFFRE_VOYAGE =
  "FunctionnalityDeleteProgrammeOffreVoyage";
export const FUNCTIONNALITY_LISTING_PROGRAMME_OFFRE_VOYAGE =
  "FunctionnalityListingProgrammeOffreVoyage";

export const FUNCTIONNALITY_CREATE_VILLE_ESCALE =
  "FunctionnalityCreateVilleEscale";
export const FUNCTIONNALITY_UPDATE_VILLE_ESCALE =
  "FunctionnalityUpdateVilleEscale";
export const FUNCTIONNALITY_DELETE_VILLE_ESCALE =
  "FunctionnalityDeleteVilleEscale";
export const FUNCTIONNALITY_LISTING_VILLE_ESCALE =
  "FunctionnalityListingVilleEscale";

export const FUNCTIONNALITY_CREATE_PROPRIETE_OFFRE_VOYAGE =
  "FunctionnalityCreateProprieteOffreVoyage";
export const FUNCTIONNALITY_UPDATE_PROPRIETE_OFFRE_VOYAGE =
  "FunctionnalityUpdateProprieteOffreVoyage";
export const FUNCTIONNALITY_DELETE_PROPRIETE_OFFRE_VOYAGE =
  "FunctionnalityDeleteProprieteOffreVoyage";
export const FUNCTIONNALITY_LISTING_PROPRIETE_OFFRE_VOYAGE =
  "FunctionnalityListingProprieteOffreVoyage";

export const FUNCTIONNALITY_CREATE_CARACTERISTIQUE_OFFRE_VOYAGE =
  "FunctionnalityCreateCaracteristiqueOffreVoyage";
export const FUNCTIONNALITY_UPDATE_CARACTERISTIQUE_OFFRE_VOYAGE =
  "FunctionnalityUpdateCaracteristiqueOffreVoyage";
export const FUNCTIONNALITY_DELETE_CARACTERISTIQUE_OFFRE_VOYAGE =
  "FunctionnalityDeleteCaracteristiqueOffreVoyage";
export const FUNCTIONNALITY_LISTING_CARACTERISTIQUEE_OFFRE_VOYAGE =
  "FunctionnalityListingCaracteristiqueOffreVoyage";

export const FUNCTIONNALITY_CREATE_GARE_TRANSPORT =
  "FunctionnalityCreateGareTransport";
export const FUNCTIONNALITY_UPDATE_GARE_TRANSPORT =
  "FunctionnalityUpdateGareTransport";
export const FUNCTIONNALITY_DELETE_GARE_TRANSPORT =
  "FunctionnalityDeleteGareTransport";
export const FUNCTIONNALITY_LISTING_GARE_TRANSPORT =
  "FunctionnalityListingGareTransport";

export const FUNCTIONNALITY_CREATE_BAGAGE = "FunctionnalityCreateBagage";
export const FUNCTIONNALITY_UPDATE_BAGAGE = "FunctionnalityUpdateBagage";
export const FUNCTIONNALITY_DELETE_BAGAGE = "FunctionnalityDeleteBagage";
export const FUNCTIONNALITY_LISTING_BAGAGE = "FunctionnalityListingBagage";

export const FUNCTIONNALITY_CREATE_MODE_ABONNEMENT =
  "FunctionnalityCreateModeAbonnement";
export const FUNCTIONNALITY_UPDATE_MODE_ABONNEMENT =
  "FunctionnalityUpdateModeAbonnement";
export const FUNCTIONNALITY_DELETE_MODE_ABONNEMENT =
  "FunctionnalityDeleteModeAbonnement";
export const FUNCTIONNALITY_LISTING_MODE_ABONNEMENT =
  "FunctionnalityListingModeAbonnement";

export const FUNCTIONNALITY_CREATE_MODE_PAIEMENT =
  "FunctionnalityCreateModePaiement";
export const FUNCTIONNALITY_UPDATE_MODE_PAIEMENT =
  "FunctionnalityUpdateModePaiement";
export const FUNCTIONNALITY_DELETE_MODE_PAIEMENT =
  "FunctionnalityDeleteModePaiement";
export const FUNCTIONNALITY_LISTING_MODE_PAIEMENT =
  "FunctionnalityListingModePaiement";

export const FUNCTIONNALITY_CREATE_USER_FUNCTION =
  "FunctionnalityCreateUserFunction";
export const FUNCTIONNALITY_CREATE_USER_ROLE = "FunctionnalityCreateUserRole";
export const FUNCTIONNALITY_CREATE_USER_ACCOUNT =
  "FunctionnalityCreateUserAccount";
export const FUNCTIONNALITY_MANAGING_ROLE_AND_FUNCTIONNALITY =
  "FunctionnalityManagingRoleAndFunctionUser";

export const FUNCTIONNALITY_MANAGE_ALL_ACCOUNT_USER =
  "FunctionnalityListingUserAccount";

/* FONCTIONNALITÉS POUR L'ENTITÉ VENDEUR */
export const FUNCTIONNALITY_RESERVE_TICKET =
  "FunctionnalityReserveTicketInStation";
export const FUNCTIONNALITY_RESERVING_FROM_OFFRE_VOYAGE =
  "FunctionnalityChooseOffreVoyage";
export const FUNCTIONNALITY_SELECTION_RESERVATION_TICKET =
  "functionnalitySelectTicketRservation";

export const FUNCTIONNALITY_TO_CONFIRM_TICKET = "FunctionnalityConfirmTicket";

export const FUNCTIONNALITY_TO_CHECK_TICKET = "FunctionnalityCheckTicket";

export const FUNCTIONNALITY_CHECK_TICKET = "FunctionnalityCheckTicket";

// DEFINITION DE NOUVELLES FONCTIONNALITÉS

export const FUNCTIONNALITY_MANAGE_OFFRE_VOYAGE =
  "FunctionnalityManageOffreVoyage";

export const FUNCTIONNALITY_MANAGE_BUS = "FunctionnalityManageBus";

export const FUNCTIONNALITY_MANAGE_STATION = "FunctionnalityManageStation";

export const FUNCTIONNALITY_MANAGE_RESERVATION_STATION =
  "FunctionnalityManageReservationStation";

export const FUNCTIONNALITY_MANAGE_SUBSCRIPTION_AND_PAYMENT =
  "FunctionnalityManageSubscriptionAndPayment";

export const FUNCTIONNALITY_MANAGE_SUBSCRIPTION =
  "FunctionnalityManageSubscription";

export const FUNCTIONNALITY_MANAGE_PAYMENT = "FunctionnalityManagePayment";

export const FUNCTIONNALITY_MANAGE_ACCOUNT = "FunctionnalityManageAccount";

export const FUNCTIONNALITY_MANAGE_ROLE_AND_PERMISSIONS =
  "FunctionnalityManageRoleAndPermissions";

export const FUNCTIONNALITY_MANAGE_COUNTRY = "FunctionnalityManageCountry";

export const FUNCTIONNALITY_MANAGE_TOWN = "FunctionnalityManageTown";

export const FUNCTIONNALITY_MANAGE_LOCALISATION =
  "FunctionnalityManageLocalisation";

export const FUNCTIONNALITY_MANAGE_ADHESION = "FunctionnalityManageAdhesion";

export const FUNCTIONNALITY_MANAGE_STRATEGIE_BAGS =
  "FunctionnalityManageStrategieBags";

export const FUNCTIONNALITY_MANAGE_DOCUMENT = "FunctionnalityManageDocument";

export const FUNCTIONNALITY_MANAGE_WALLET = "FunctionnalityManageWallet";

export const FUNCTIONNALITY_MANAGE_NOTIFICATION =
  "FunctionnalityManageNotification";

export const FUNCTIONNALITY_MANAGE_BAGS = "FunctionnalityManageBags";

export const FUNCTIONALITY_MANAGE_CATEGORIE_VOYAGEUR =
  "FunctionnalityManageCategorieVoyageur";

export const FUNCTIONALITY_MANAGE_REFERENCE = "FunctionnalityManageReference";

export const FUNCTIONALITY_ONLY_USER_SIMPLE = "FunctionnalityOnlyUserSimple";
